var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"btn_back",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.doBack.apply(null, arguments)}}},[_vm._v("もどる")])])}
var staticRenderFns = []

export { render, staticRenderFns }